var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidatorCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 48,
    viewBox: "0 0 144 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6875 35.7285C61.6875 33.9336 63.1426 32.4785 64.9375 32.4785H65.0731C66.868 32.4785 68.3231 33.9336 68.3231 35.7285V37.4912C68.3231 39.2862 66.868 40.7412 65.0731 40.7412H64.9375C63.1426 40.7412 61.6875 39.2862 61.6875 37.4912V35.7285Z",
    fill: "#475467",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9922 10.5083C55.9922 8.71338 57.4473 7.2583 59.2422 7.2583H70.7676C72.5625 7.2583 74.0176 8.71337 74.0176 10.5083V30.9829C74.0176 32.7778 72.5625 34.2329 70.7676 34.2329H59.2422C57.4473 34.2329 55.9922 32.7778 55.9922 30.9829V10.5083Z",
    fill: "#F9F9FB",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6826 11.4394C57.6826 10.1609 58.8657 9.21063 60.1141 9.48646L69.0642 11.464C69.9166 11.6523 70.5483 12.3717 70.625 13.2413L72.1349 30.3668C72.238 31.5361 71.3165 32.5424 70.1426 32.5424H59.6826C58.578 32.5424 57.6826 31.647 57.6826 30.5424V11.4394Z",
    fill: "#667085"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3491_73710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8561 33.8681C82.0322 35.6167 79.9468 36.3664 78.1982 35.5425L62.074 27.9453C60.3254 27.1215 59.5758 25.036 60.3997 23.2874L64.1444 15.3396C64.9683 13.591 67.0537 12.8414 68.8023 13.6653L84.9265 21.2624C86.6751 22.0863 87.4247 24.1718 86.6008 25.9204L82.8561 33.8681Z",
    fill: "white",
    stroke: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2088 21.1688C66.9895 19.512 68.3641 18.2432 70.0804 17.5955C70.3399 17.4974 70.6311 17.6286 70.7301 17.8878C70.7806 18.0204 70.7711 18.1613 70.7152 18.2798C70.6617 18.3933 70.5656 18.4874 70.4384 18.5351C68.9676 19.0909 67.7892 20.1785 67.1202 21.5983C66.4513 23.018 66.3628 24.6192 66.8707 26.1072C66.9616 26.3693 66.8209 26.6549 66.5572 26.7443C66.2945 26.8326 66.0077 26.6919 65.9184 26.4289C65.3251 24.693 65.4284 22.8252 66.2088 21.1688ZM68.4866 22.2405C67.967 23.3432 67.9181 24.63 68.3532 25.7713C68.4528 26.0303 68.7434 26.1617 69.0031 26.0631C69.2629 25.9657 69.3937 25.6749 69.2948 25.4158C68.956 24.5285 68.9937 23.5278 69.398 22.6699C69.8022 21.8119 70.5499 21.1458 71.4497 20.8421C71.5842 20.7967 71.6867 20.6996 71.7428 20.5806C71.7963 20.4671 71.8076 20.3331 71.7633 20.2051C71.6739 19.9421 71.3876 19.8016 71.1245 19.8897C69.9673 20.2808 69.0062 21.1377 68.4866 22.2405ZM70.7668 23.3163C70.488 23.9081 70.4515 24.5752 70.6629 25.1949C70.753 25.4576 71.0391 25.5986 71.302 25.5098C71.5657 25.4204 71.7064 25.1349 71.6159 24.873C71.3618 24.1289 71.7722 23.2577 72.5079 22.98C72.6344 22.9325 72.7309 22.8386 72.7844 22.7251C72.8405 22.6061 72.8501 22.4652 72.7991 22.3324C72.7001 22.0732 72.4093 21.9423 72.1494 22.0401C71.5369 22.2716 71.0456 22.7245 70.7668 23.3163Z",
    fill: "#1D2939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3491_73710",
    x: 53.5645,
    y: 8.83057,
    width: 39.8711,
    height: 35.5469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3491_73710"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3491_73710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3491_73710",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatorCard);
export default __webpack_public_path__ + "static/media/validator_card.ec9a215cc45d5cb2331d3c0a4cd31c92.svg";
export { ForwardRef as ReactComponent };